<div
    style="
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: center;
    "
>
    <div class="border dx-theme-border-color menubox">
        <div class="border-header dx-theme-border-color-as-background-color">Job Manager</div>
        <div>
            <div class="admin-button">
                <dx-button text="Queue Export to Surebank" (onClick)="ExportToSureBank()"></dx-button>
            </div>
            <div class="admin-button">
                <dx-button text="Queue Import From Surebank" (onClick)="ImportFromSureBank()"></dx-button>
            </div>
            <div class="admin-button">
                <dx-button text="Void/Refund Processed Payments" (onClick)="FinalizePayments()"></dx-button>
            </div>
            <div class="admin-button">
                <dx-button text="Queue Job Processor" (onClick)="JobQueue_Job()"></dx-button>
            </div>
            <div class="admin-button">
                <dx-button text="Send Daily TP Status Email" (onClick)="TrafficaPayNewPayments_Job()"></dx-button>
            </div>
            <div class="admin-button">
                <a [href]="jobViewerURL" target="_blank">Launch Job Viewer</a>
            </div>
        </div>
    </div>

    <div class="border dx-theme-border-color menubox">
        <div class="border-header dx-theme-border-color-as-background-color">General</div>
        <div>
            <div class="link">
                <a routerLink="/user/manager">AD.5 User Manager</a>
            </div>
            <div class="link" style="visibility: hidden;">
                <a routerLink="/admin/site/list">SL.1 Site List</a>
            </div>
            <div class="link" style="visibility: hidden;">
                <a routerLink="/admin/payment/transactions">OP.1A Payment Transaction List</a>
            </div>
            <div class="link">
                <a routerLink="/admin/cc-info-maintenance">SM.1 Site Maintenance</a>
            </div>
        </div>
    </div>
</div>
